export default {
  // ========== Buttons and actions ==========
  evaluationsXlsx: 'EVALUATIONS XLSX',

  // ========== Table headers ==========
  evaluations: 'Evaluations',
  colSubjectCode: 'Subject Code',
  colSubject: 'Subject',
  colPlanLevel: 'Plan Level',
  colEvaluationType: 'Evaluation Type',
  colLearningOutcome: 'Learning Result',
  colAchievementIndicators: 'Achievement Indicators',
  colEvaluativeSituation: 'Evaluative Situation',
  colEvaluationDescription: 'Evaluation Description',
  colEvaluationDescriptionTooltip: 'Evaluation Description (Mention the main characteristics that configure the evaluation activity: main characteristics of the assignment, practical execution, written tests or presentation)',
  colEvaluativeAgent: 'Evaluative Agent',
  colEvaluationWeighting: 'Evaluation Weighting',
  colSituationWeighting: 'Weighting per Evaluative Situation',
  colDirectedTeachingHours: 'Directed Teaching Hours (pedagogical)',
  colAutonomousWorkHours: 'Autonomous Work Hours - Preparation and/or Execution (chronological)',
  colWorkType: 'Work Type',
  colEnvironment: 'Environment',
  colExaminer: 'Examiner',

  // ========== Messages ==========
  noDataToShow: 'No data to show',

  // ========== Breadcrumb ==========
  breadcrumbEvaluations: 'Evaluations',

  // ========== Excel download ==========
  generatingExcel: 'Generating Excel...',
  pleaseWaitWhileGenerating: 'Please wait while the file is being generated.',
  downloadError: 'Could not download the file.',
  generationError: 'There was a problem generating the file.',
}
